import React, { useEffect, useState, useRef } from "react";
import "./Start.css";
import Logo from "./Images/helloemslogo.png";
import { Button } from "primereact/button";
import Home from "./SubSections/Home/Home";
import { Link, animateScroll as scroll } from "react-scroll";
import Features from "./SubSections/Features/Features";
import AboutUs from "./SubSections/About/AboutUs";
import Contact from "./SubSections/Contact/Contact";
import Register from "./SubSections/Register";
import { Sidebar } from "primereact/sidebar";
import { FaHome } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { FcAbout } from "react-icons/fc";
import { MdAddIcCall } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import Footer from "./SubSections/Footer";
import Pricetag from "./SubSections/Contact/HelloEMSPricingNew"

const Start = () => {
  const registerRef = useRef();
  const [featuresClicked, setFeaturesClicked] = useState(false);
  const [aboutClicked, setAboutClicked] = useState(false);
  const [contactClicked, setContactClicked] = useState(false);
   const [priceClicked, setPriceClicked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setFeaturesClicked(false);
      setAboutClicked(false);
      setContactClicked(false);
      setPriceClicked(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    scroll.scrollToTop();
  };
  return (
    <div>
      <nav>
        <div className="logo-img">
          <img src={Logo} onClick={scrollToTop} alt="Logo " />
        </div>
        {!isMobile && (
          <ul className="navbar-links">
            <li className="link-elements">
              <Link
                to="Home"
                spy={true}
                target=""
                smooth={true}
                offset={-100}
                duration={500}>
                Home
              </Link>
            </li>
            <li className="link-elements" spy={true}>
              <Link
                target="features"
                to="features"
                onClick={(e) => {
                  setTimeout(() => {
                    setFeaturesClicked(true);
                  }, 600);
                }}
                className={featuresClicked ? "active" : ""}
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}>
                Features
              </Link>
            </li>
            <li className="link-elements">
              <Link
                to="AboutUs"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={(e) => {
                  setTimeout(() => {
                    setAboutClicked(true);
                  }, 600);
                }}
                className={aboutClicked ? "active" : ""}>
                About Us
              </Link>
            </li>
            <li className="link-elements">
              <Link
                to="Pricedetails"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={(e) => {
                  setTimeout(() => {
                    setPriceClicked(true);
                  }, 600);
                }}
                className={priceClicked ? "active" : ""}>
                Price
              </Link>
            </li>

            <li className="link-elements">
              <Link
                to="ContactUs"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                onClick={(e) => {
                  setTimeout(() => {
                    setContactClicked(true);
                  }, 600);
                }}
                className={contactClicked ? "active" : ""}>
                Contact Us
              </Link>
            </li>

            <li>
              <Button
                onClick={() => registerRef.current.callRegisterComponent()}
                label="Send Enquiry"></Button>
            </li>
          </ul>
        )}
        {isMobile && (
          <GiHamburgerMenu
            onClick={() => setVisible(true)}
            className="ham-burger"
          />
        )}
      </nav>
      <Register ref={registerRef} />
      <Sidebar
        header={
          <div className="logo-img">
            <img src={Logo} alt="Logo " onClick={scrollToTop} />
          </div>
        }
        visible={visible}
        onHide={() => setVisible(false)}>
        <ul className="sidebarlinks">
          <li className="link-elements">
            <FaHome className="side-bar-icon" style={{ color: "#7b1fa2" }} />
            <Link
              to="Home"
              spy={true}
              target=""
              smooth={true}
              offset={-100}
              duration={500}
              onClick={() => setVisible(false)}>
              Home
            </Link>
          </li>
          <li className="link-elements" spy={true}>
            <IoMdSettings
              className="side-bar-icon"
              style={{ color: "green" }}
            />
            <Link
              target="features"
              to="features"
              onClick={(e) => {
                setTimeout(() => {
                  setFeaturesClicked(true);
                }, 600);
                setVisible(false);
              }}
              className={featuresClicked ? "active" : ""}
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}>
              Features
            </Link>
          </li>
          <li className="link-elements">
            <FcAbout className="side-bar-icon" style={{ color: "orange" }} />
            <Link
              to="AboutUs"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              onClick={(e) => {
                setTimeout(() => {
                  setAboutClicked(true);
                }, 600);
                setVisible(false);
              }}
              className={aboutClicked ? "active" : ""}>
              About Us
            </Link>
          </li>
                    <li className="link-elements">
            <MdAddIcCall className="side-bar-icon" style={{ color: "brown" }} />
            <Link
              to="Pricedetails"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              onClick={(e) => {
                setTimeout(() => {
                  setPriceClicked(true);
                }, 600);
                setVisible(false);
              }}
              className={priceClicked ? "active" : ""}>
              Price
            </Link>
          </li>
          <li className="link-elements">
            <MdAddIcCall className="side-bar-icon" style={{ color: "brown" }} />
            <Link
              to="ContactUs"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              onClick={(e) => {
                setTimeout(() => {
                  setContactClicked(true);
                }, 600);
                setVisible(false);
              }}
              className={contactClicked ? "active" : ""}>
              Contact Us
            </Link>
          </li>
        </ul>
      </Sidebar>
      <div id="Home" style={{ marginBottom: "40px" }}>
        <Home />
      </div>
      <div id="features" style={{ marginBottom: "40px" }}>
        <Features />
      </div>
      <div id="AboutUs" style={{ marginBottom: "40px" }}>
        <AboutUs />
      </div>
      <div id="Pricedetails" style={{ marginBottom: "40px" }}>
        <Pricetag />
      </div>
      <div id="ContactUs" style={{ marginBottom: "40px" }}>
        <Contact />
      </div>
      <Footer />
    </div>
  );
};

export default Start;
